<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.contact.contact.fields.name.label')"
                    :placeholder="$t('forms.contact.contact.fields.name.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="name"
                    @change="change"
                ></text-input>
            </form-cell>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.contact.contact.fields.email.label')"
                    :placeholder="$t('forms.contact.contact.fields.email.placeholder')"
                    :isRequired="true"
                    type="email"
                    valuePath="email"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.contact.contact.fields.phone.label')"
                    :placeholder="$t('forms.contact.contact.fields.phone.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="phone"
                    @change="change"
                ></text-input>
            </form-cell>
            <form-cell width="half">
                <text-input
                    :formData="data"
                    :label="$t('forms.contact.contact.fields.company.label')"
                    :placeholder="$t('forms.contact.contact.fields.company.placeholder')"
                    :isRequired="false"
                    type="text"
                    valuePath="company"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row></form-row>
        <form-row>
            <form-cell>
                <textarea-input
                    :formData="data"
                    :label="$t('forms.contact.contact.fields.description.label')"
                    :placeholder="$t('forms.contact.contact.fields.description.placeholder')"
                    valuePath="message"
                    @change="change"
                ></textarea-input>
            </form-cell>
        </form-row>
        <form-row>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :size="'large-long'"
                    :label="$t('forms.contact.contact.buttons.send')"
                ></common-button>
            </common-buttons>
        </form-row>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import AuthAPI from 'api/AuthAPI'
    import RoutesEnum from 'enums/routes.enum'
    import Store from '@/store'

    export default {
        mixins: [FormMixin],

        methods: {
            submit() {
                const request = {
                    email: this.data.email,
                    phone: this.data.phone,
                    name: this.data.name,
                    message: this.data.message,
                    company: this.data.company,
                    language: this.$i18n.locale,
                }

                if (this.$auth.isSubdomainActive()) {
                    AuthAPI.subdomainSupport(request, Store.getters['data/getSubdomainCompany'].id).then(() => {
                        this.$toast.success(this.$t('forms.contact.contact.success.message'))
                        this.$router.push({ name: RoutesEnum.SUBDOMAIN.COMPANY })
                    })
                } else {
                    AuthAPI.support(request).then(() => {
                        this.$toast.success(this.$t('forms.contact.contact.success.message'))
                        this.$router.push({ name: RoutesEnum.INDEX.HOME })
                    })
                }
            },
        },
    }
</script>
